import { GroupBy } from '../types';

const pad = (n: number) => String(n).padStart(2, '0');

// Theo giờ máy, không qua toISOString (UTC làm lệch ngày)
const toYmd = (d: Date) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export function formatPeriod(period: string, groupBy: GroupBy): string {
  if (groupBy === 'week') {
    const [year, week] = period.split('-W');
    return `Tuần ${Number(week)}/${year}`;
  }
  if (groupBy === 'month') {
    const [year, month] = period.split('-');
    return `Th${Number(month)}/${year}`;
  }
  const [, month, day] = period.split('-');
  return `${day}/${month}`;
}

// 30 ngày gần nhất gồm cả hôm nay
export function defaultRange(today: Date): { from: string; to: string } {
  const from = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 29);
  return { from: toYmd(from), to: toYmd(today) };
}
